import { gql } from '@apollo/client';

export function generateMedicalGroupCertificateOutput() {
  return gql`
    mutation generateMedicalCertificateOutput(
      $entityId: String!
      $certificateDetailsOutputInput: [Production_MedicalCertificateDetailsOutputInput!]!
    ) {
      production {
        entities {
          policy {
            production {
              generateMedicalCertificateOutput(
                entityId: $entityId
                medicalCertificateDetailsOutputInput: $certificateDetailsOutputInput
              )
            }
          }
        }
      }
    }
  `;
}
